import { Color } from "../Color";

export enum BadgeVariant {
  Notification = "notification",
  Status = "status",
}

interface CommonBadgeProps {
  /** String id used for querying in testing environments */
  "data-test-id"?: string;
  /**
   * The variant of badge that should be used
   * @default 'status'
   */
  variant?: BadgeVariant;
  className?: string;
}

export interface NotificationBadgeProps extends CommonBadgeProps {
  /**
   * Background color of the badge.
   * @default 'Core.surface.subdued'
   */
  backgroundColor?: Color;
  /** Text to be displayed in the badge. */
  content: number;
  /**
   * Sets the color of the text.
   * @default 'Core.text.default'
   */
  contentColor?: Color;
  /** Optional prop to show a notification dot on the top-right corner */
  notificationDot?: boolean;
  /** The variant of badge that should be used. */
  variant: BadgeVariant.Notification;
}

export interface StatusBadgeProps extends CommonBadgeProps {
  /** Background color of the badge. */
  backgroundColor: Color;
  /** Border color of the badge. */
  borderColor?: Color;
  /** Text to be displayed in the badge. */
  content: string;
  /**
   * Sets the color of the text. Will also set color of divider if not specified.
   * @default 'Core.text.default'
   */
  contentColor?: Color;
  /** Sets the color of the divider between the prefix and the content. */
  dividerColor?: Color;
  /** Text to be displayed before the content, separated by a divider. */
  prefix?: string;
  /** The variant of badge that should be used. */
  variant?: BadgeVariant.Status;
}

export type BadgeProps = NotificationBadgeProps | StatusBadgeProps;
